import { cn } from '../../lib/cn';
import { fmtDateNumeric } from '../../utils/dates';

export interface DateTextProps {
  /** ISO YYYY-MM-DD (longer ISO strings are truncated to the date part). */
  value: string | null | undefined;
  className?: string;
}

/**
 * Zero-padded MM/DD/YYYY so date columns align under tabular figures —
 * 01/05/2024 sits flush over 12/25/2024. String-split parsing, never
 * `new Date(iso)` (UTC shift moves statement dates a day on non-UTC machines).
 */
export default function DateText({ value, className }: DateTextProps) {
  const classes = cn('tabular-nums whitespace-nowrap', className);
  if (!value) return <span className={classes}>—</span>;
  return (
    <time dateTime={value.slice(0, 10)} className={classes}>
      {fmtDateNumeric(value)}
    </time>
  );
}
